@use '@snowit/style/mixins';

:global(.mapboxgl-popup-content) {
  padding: 0.5rem;
  background: transparent;
  box-shadow: none;
}

:global(.mapboxgl-popup-tip) {
  display: none;
}

// Controllers icons override
:global {
  .mapboxgl-ctrl button .mapboxgl-ctrl-icon {
    background-size: 1rem;
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-zoom-out .mapboxgl-ctrl-icon {
    background-image: var(--icon-zoom-out);
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-zoom-in .mapboxgl-ctrl-icon {
    background-image: var(--icon-zoom-in);
  }
}

// Popup
.popup > * {
  border-radius: 0;
  box-shadow: none;
}

// Marker
.marker {
  transition: var(--transition-025);

  @include mixins.media(noTouch) {
    &:hover {
      z-index: var(--z-index-top);
    }
  }
}

// Map pin label
.pinLabel {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  min-width: 0.75rem;
  height: 0.75rem;
  border: 0.125rem solid var(--c-body);
  border-radius: 1.75rem;
  background: var(--c-text);
  box-shadow: var(--sw-dp4);
  font-family: var(--ff);
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  line-height: 0.75rem;
  text-align: center;
  color: var(--c-text);
  transition: var(--transition-025);
  cursor: pointer;

  .label {
    color: var(--c-text);
  }

  @include mixins.media(noTouch) {
    &:hover {
      box-shadow: var(--sw-dp8);
      transform: scale(1.077);
    }
  }
}

// If Map pin label showLabel
.pinLabel.showLabel {
  min-width: 1.75rem;
  height: 1.75rem;
  padding: 0 0.5rem;
  border: 1px solid var(--c-bg-d4);
  border-radius: 1.75rem;
  background: var(--c-body);
}

// If Map pin label highlighted
.pinLabel.highlighted {
  border-color: var(--c-primary);
  background: var(--c-primary);

  .label {
    color: var(--c-white);
  }
}

// If Map pin icon highlighted
.pinIcon.highlighted {
  fill: var(--c-primary);
}

// If Map pin icon withRadius
.pinIcon.withRadius {
  position: relative;
  padding: 1.5rem;
  border-radius: 50%;
  background: rgb(6 148 249 / 10%);
  background-color: color-mix(in srgb, var(--c-primary) 10%, transparent);
}
